import Interweave from "interweave";

import LongText from "./LongText";
import styles from "./MeetTheTeamComponent.module.css";
import TeamMemberCard from "./TeamMemberCard";

export default function MeetTheTeamComponent({ data }) {
  const { sub_heading, main_section, team_members } = data;

  return (
    <section className={`${styles.team_container} fixed-nav`}>
      <div className={styles.team_container_bg}></div>
      <div className={styles.meet_team_container_icon1}></div>
      <div className={styles.meet_team_container_icon2}></div>
      <div className="container-fluid">
        <div className={styles.team_heading}>
          <h1>{sub_heading?.value}</h1>
          <Interweave
            allowElements={false}
            content={sub_heading?.description}
          />
        </div>
        <div className={`row justify-content-center ${styles.team_member} ${styles.team_image_wrapper}`}>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div>
              <div
                className={`${styles.team_card_image} ${styles.team_card_desig_box_img}`}
              >
                <img
                  className={`${styles.team_image} ${styles.team_card_desig_img} default`}
                  src={process.env.IMAGE_LINK + main_section?.value}
                  alt="about us"
                />
                {main_section?.overLayImage && (
                  <img
                    className={`${styles.team_image} ${styles.team_card_desig_img} overlay`}
                    src={
                      process.env.IMAGE_LINK +
                      main_section?.overLayImage
                    }
                    alt="about us"
                  />
                )}
              </div>
            </div>
          </div>
          <div className={`col-lg-6  col-md-6 col-sm-6 col-xs-12 ${styles.team_member_content} `}>
            <h5 className={styles.team_member_name}>{main_section?.title}</h5>
            <h6 className={styles.team_member_designation}>
              {main_section?.subTitle}
            </h6>
            <p className={`${styles.team_member_para_height} ${styles.team_member_ceo}`}>
              {/* <Interweave
                allowElements={false}
                content={main_section?.description}
              /> */}
                            {main_section !== "" && main_section !== undefined && (
                              <LongText content={main_section?.description.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/g, '') } limit={600} />
                            )}
            </p>
          </div>
        </div>
        <div className={` col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles.team_member_list}`}>
          {team_members !== null &&
            team_members.content.map((member, indx) => (
              <TeamMemberCard key={indx} content={member} />
            ))}
        </div>
      </div>
    </section>
  );
}
